module.exports = __webpack_public_path__ + "src/assets/games/53/zy.png";